/* eslint-disable react/no-array-index-key */
import React from 'react';
import type { ReactElement } from 'react';
import {
  Box,
  Dialog,
  Paper,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import type { VerificationViewProps } from './types';
import './verification.scss';
import VerifyForm from './verification-code-form';

const VerificationView = ({
  email,
  onSubmit,
  submissionError,
  clearSubmissionError,
  onResendCode,
  initialCode,
}: VerificationViewProps): ReactElement => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: isDesktop ? 'flex-start' : 'center',
        justifyContent: 'center',
        py: { mobile: 2, md: 4 },
        bgcolor: isDesktop ? '#f5f5f5' : 'transparent',
      }}
    >
      {isDesktop ? (
        <Dialog
          open
          aria-labelledby="verification-modal-title"
          aria-describedby="verification-modal-description"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Paper
            elevation={6}
            sx={{
              p: { xs: 2, sm: 3, md: 4 },
              maxWidth: '390px',
              maxHeight: '95vh',
              overflowY: 'auto',
              borderRadius: '16px',
              position: 'relative',
              zIndex: theme.zIndex.modal,
            }}
          >
            <VerifyForm
              email={email}
              isDesktop={isDesktop}
              onSubmit={onSubmit}
              submissionError={submissionError}
              clearSubmissionError={clearSubmissionError}
              onResendCode={onResendCode}
              initialCode={initialCode}
            />
          </Paper>
        </Dialog>
      ) : (
        <VerifyForm
          email={email}
          isDesktop={isDesktop}
          onSubmit={onSubmit}
          submissionError={submissionError}
          clearSubmissionError={clearSubmissionError}
          onResendCode={onResendCode}
          initialCode={initialCode}
        />
      )}
    </Box>
  );
};

export default VerificationView;
